
import { Vue } from "vue-class-component";

export default class BookingInstantV2 extends Vue {}
